class Footer
    constructor: (el) ->
        @.$el = el
        @.$activeNavLink = @.$el.querySelector '.footer__top__main-nav .footer--active-link, .footer__bot__meta-nav .footer--active-link'
        @.$links = @.$el.querySelectorAll 'a'
        @.$toTopButton = @.$el.querySelector '.footer__top__head__back-to-top'

        @.CheckForActiveNavigationLink()
        @.InitEvents()
        @.$el.classList.add 'footer--bound'
        return

    CheckForActiveNavigationLink: ->
        if !@.$activeNavLink
            locationPathname = window.location.pathname
            if locationPathname.substring(locationPathname.lastIndexOf('/') + 1) == ""
                locationPathname = locationPathname.slice(0,-1)
            lastUrlPart = locationPathname.substring locationPathname.lastIndexOf('/') + 1
            @.$links.forEach (linkEl) ->
                linkElHref = linkEl.href
                if linkElHref.substring(linkElHref.lastIndexOf('/') + 1) == ""
                    linkElHref = linkElHref.slice(0,-1)
                linkElLastUrlPart = linkElHref.substring linkElHref.lastIndexOf('/') + 1
                if linkElLastUrlPart != ""
                    if lastUrlPart.includes linkElLastUrlPart
                        linkEl.classList.add 'footer--active-link'
                    else
                        linkEl.classList.remove 'footer--active-link'
                else
                    linkEl.classList.remove 'footer--active-link'
                return
        return
    
    InitEvents: ->
        @.$toTopButton.addEventListener 'click', (e) ->
            window.scrollTo {
                behavior: 'smooth',
                left: 0,
                top: 0
            }
            return
        return

BindFooters = ->
    document.querySelectorAll '.footer:not(.footer--bound)'
        .forEach (el) ->
            new Footer el
            return
    return

window.addEventListener 'bind-components', BindFooters